import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AllBookingsIndex } from '@/pages/all-bookings/AllBookingsIndex';

const bookingsSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(10),
	search: z.string().optional(),
	status: z.string().optional(),
	assignedToUser: z.string().optional(),
	serviceId: z.string().optional(),
	from: z.string().optional(),
	to: z.string().optional(),
	view: z.enum(['list', 'calendar']).default('list'),
});

export const Route = createFileRoute('/_authenticated/_app/bookings/manage')({
	component: AllBookingsIndex,
	validateSearch: bookingsSearchSchema,
});
